import React, {useState} from "react"
import Icon from "../Icon/Icon"

export default function Disclaimer() {
	const [expanded, setExpanded] = useState(false)

	const summaryText = "The interest information displayed here is a snapshot based on the current interest setup."
	const fullText =
		"The interest information displayed here is a snapshot based on the current interest setup. Please note that the actual interest payout is determined by an end-of-month calculation, which may vary depending on the configured interest modes and fluctuations in federal rates throughout the month."

	return (
		<div className="disclaimer-section">
			<div className="disclaimer-header">
				<Icon icon="alert-triangle--interface-essential" size={16} className="disclaimer-icon" />
				<span className="disclaimer-label">Disclaimer</span>
			</div>
			<p className="disclaimer-text">
				{expanded ? fullText : `${summaryText.slice(0, summaryText.length - 1)}...`}{" "}
				<span className="disclaimer-toggle" onClick={() => setExpanded(!expanded)}>
					{expanded ? "read less" : "read more"}
				</span>
			</p>
		</div>
	)
}
